export default class CreditCard {
  static getCardFlag (cardNumber) {
    const amex = /^3[47][0-9]{13}$/
    const visa = /^4[0-9]{12}(?:[0-9]{3})?$/
    const cup1 = /^62[0-9]{14}[0-9]*$/
    const cup2 = /^81[0-9]{14}[0-9]*$/
    
    const mastercard = /^5[1-5][0-9]{14}$/
    const mastercard2 = /^2[2-7][0-9]{14}$/
  
    const disco1 = /^6011[0-9]{12}[0-9]*$/
    const disco2 = /^62[24568][0-9]{13}[0-9]*$/
    const disco3 = /^6[45][0-9]{14}[0-9]*$/
    
    const diners = /^3[0689][0-9]{12}[0-9]*$/
    const jcb =  /^35[0-9]{14}[0-9]*$/

    const formattedNumber = cardNumber.replace (/ /g, '')
  
    if (visa.test (formattedNumber))
      return 'VISA'

    if (mastercard.test (formattedNumber) || mastercard2.test (formattedNumber))
      return 'MASTERCARD'

    if (amex.test (formattedNumber))
      return 'AMEX'

    if (disco1.test (formattedNumber) || disco2.test (formattedNumber) || disco3.test (formattedNumber))
      return 'DISCOVER'

    if (diners.test (formattedNumber))
      return 'DINERS'

    if (jcb.test (formattedNumber))
      return 'JCB'
      
    if (cup1.test (formattedNumber) || cup2.test (formattedNumber))
      return 'CHINA_UNION_PAY'

    return undefined
  }
}
